var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-location"},[(_vm.address)?_c('span',[_vm._v("\n    "+_vm._s(_vm.address)),_c('br')]):_vm._e(),_c('a',{attrs:{"href":_vm.yaMapLink,"target":"_blank"}},[_vm._v("Открыть в Yandex Maps")])])}
var staticRenderFns = []

export { render, staticRenderFns }